import { Button, Input } from '@design-system';

import { Check, Copy } from 'lucide-react';

import { useCopyToClipboard } from '@/hooks/use-copy-to-clipboard';

interface GeneratedInviteLinkProps {
  link: string;
}

export function GeneratedInviteLink({ link }: GeneratedInviteLinkProps) {
  const { copied, copy } = useCopyToClipboard(link);

  return (
    <div className="flex items-center gap-2">
      <Input
        id="generated-invite-link"
        readOnly
        value={link}
        onFocus={({ target }) => target.select()}
      />
      <Button
        type="button"
        variant="outline"
        onClick={copy}
      >
        {copied ? <Check className="size-4" /> : <Copy className="size-4" />}
        {copied ? 'Copied' : 'Copy'}
      </Button>
    </div>
  );
}
